export const calendar = {
  title: "Calendar",
  subtitle: "Manage your properties’ bookings",
  createBooking: "Create booking",
  propertyLabel: "Accommodation",
  searchPlaceholder: "Search accommodation",
  filterByProperty: "Filter properties",
  clearFilters: "Clear filters",
  loadingMore: "Loading more dates…",

  payment: {
    "pending":  "Payment pending",
    "paid":     "Paid",
    "rejected": "Payment rejected",
    "refunded": "Refunded",
    "partial":  "Partial payment"
  },

  tooltips: {
    noChannels: "Not connected to any channel",
    connectedTo: "Connected to: {channels}",
    manual: "WA Checkin (manual)",
    other: "Other channel",
    configPrices: "Configure prices",
  },

  errors: {
    loadCalendar: "Error loading calendar data",
    updateViewAfterCancel: "Error updating the view after cancellation",
    closeDates: "Error closing dates",
    deleteClosedDates: "Error deleting closed dates",
    updateClosedDates: "Error updating closed dates",
  },

  filters: {
    showPrices: "Show prices",
    today: "Today",
    multi: "Multiple",
    monthly: "Monthly",
    prevMonthAria: "Previous month",
    nextMonthAria: "Next month",
  },

  actions: {
    title: "Select an action",
    question: "What would you like to do with the selected dates?",
    createBooking: "Create booking",
    blockDates: "Close date",
    editNightPrice: "Edit price per night",
    editMinStay: "Minimum stay",
    editMinStayHint: "Set the minimum number of nights per date",
  },
  minStayModal: {
    description:
      "Set the minimum stay for the selected date range. This will not affect existing prices.",
    success: "Minimum stay updated successfully",
    hint: "Minimum number of nights the guest must book.",
    errors: {
      minOne: "Minimum stay must be at least 1 night.",
    },
  },

  fields: {
    startDate: "Start date",
    endDate: "End date",
  },

  buttons: {
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    close: "Close",
    saveChanges: "Save changes",
    closeDates: "Close dates",
  },

  closeModal: {
    headerCreate: "CLOSE DATES",
    headerEdit: "EDIT CLOSED DATES",
  },

  priceModal: {
    description:
      "This is a manual change to the rate you select. Everything you change here will affect only this accommodation and this date range.",
    periodLabel: "Date period",
    startPlaceholder: "Start date",
    endPlaceholder: "End date",
    pricePerNight: "Price per night",
    minStay: "Minimum stay",
    minNightsPlaceholder: "Minimum nights",
    pricePlaceholder: "Price for the selected range",
    success: "Prices updated successfully",
    errors: {
      invalidRange: "You must select a valid date range",
      startAfterEnd: "Start date cannot be later than end date",
      minStay:
        "The minimum stay is {min} nights, but the selected range has {nights} nights",
      missingSelection: "No property or date range has been selected",
      request: "Request error: {msg}",
      update: "Error updating prices: {msg}",
    },
  },

  details: {
    header: "Booking details",
    title: "Booking",
    createdOn: "Created on {date}",
    checkIn: "Check-in",
    checkOut: "Check-out",
    arrow: "→",
    statusLabel: "Status",
    status: {
      booked: "Booked",
      blocked: "Blocked",
    },
    night_one: "Night",
    night_other: "Nights",
    actions: {
      view: "View booking",
      changeRoom: "Change room",
      cancel: "Cancel booking",
    },
  },
};

export default calendar;
